(function () {
  'use strict';

  angular.module('wsLrs.services').service('CsvUpload', ['$http', '$interval', '$q', 'Api', 'User', 'Utils', 'xsrf', function ($http, $interval, $q, Api, User, Utils, xsrf) {
    return function CsvUpload(url) {
      var self = {
        url: url,
        pollRate: 1000,
        self: this,
        // objects to help with file uploads
        importFiles: {},
        voidFiles: {},
        checkCsvFormat: function checkCsvFormat(files) {
          //make sure all file types are csv
          var isValid = true;
          for (var i = 0; i < files.length; i++) {
            var fileName = files[i].name,
              fileExtension = "";
            if (fileName.lastIndexOf(".") > 0) {
              fileExtension = fileName.substring(fileName.lastIndexOf(".") + 1);
            }
            if (fileExtension !== "csv") {
              isValid = false;
            }
          }
          return isValid;
        },
        setFiles: function setFiles(element) {
          // Turn the FileList object into an Array
          var files = [];
          for (var i = 0; i < element.files.length; i++) {
            files.push(element.files[i]);
          }
          if (!self.checkCsvFormat(files)) {
            return false;
          }
          return files;
        },
        uploadFiles: function uploadFiles(files) {
          var deferred = $q.defer();
          function responseHandler(e) {
            /* This event is raised when the server send back a response */
            if (e.target.status === 202) {
              deferred.resolve(Utils.getIdFromURL(e.target.responseText));
            } else {
              deferred.reject(e);
            }
          }
          for (var i = 0; i < files.length; i++) {
            var file = files[i];
            var xhr = new XMLHttpRequest();
            xhr.addEventListener("load", responseHandler, false);
            xhr.open("POST", Api.url(self.url) + '?template=legacy&file=' + encodeURIComponent(file.name));
            var fileExtension = "";
            if (file.name.lastIndexOf(".") > 0) {
              fileExtension = file.name.substring(file.name.lastIndexOf(".") + 1, file.name.length);
            }
            xhr.setRequestHeader("Content-Type", fileExtension === "csv" || !file.type ? "text/csv" : file.type);
            xhr.setRequestHeader("Authorization", User.get().auth);
            xsrf.addHeadersToXhr(xhr);
            xhr.send(file);
          }
          return deferred.promise;
        },
        fetchJobs: function fetchJobs(params) {
          params = params || {};
          return $http.get(Api.url(self.url), {
            params: params
          }).then(function getPastStatementImportsSuccess(response) {
            return response.data;
          });
        },
        waitForCompletion: function waitForCompletion(jobId, pollRate) {
          var deferred = $q.defer();
          var jobUrl = Api.url(self.url + "/" + jobId);
          pollRate = pollRate || this.pollRate;
          var stop = $interval(function pollJobEntity() {
            return $http.get(jobUrl).then(function readResponse(response) {
              if (!(response.data.status === "completed" || response.data.status === "aborted")) {
                deferred.notify(response.data);
                return;
              }
              var data = response.data;
              var rows = data.messages;
              if (rows.length > 2) {
                deferred.reject(data);
              }
              deferred.resolve(data);
              $interval.cancel(stop);
              stop = undefined;
            }, function (err) {
              deferred.reject(err);
            });
          }, pollRate);
          return deferred.promise;
        },
        deleteUpload: function deleteUpload(fileId) {
          return $http['delete'](Api.url(self.url + "/" + fileId));
        }
      };
      return self;
    };
  }]);
})();
